<template>
  <eagle-list :list-key="listKey"></eagle-list>
</template>

<script lang="babel" type="text/babel">
import listMixin from '@/components/list/mixins/listMixin'
import listConfig from './cooperationStoreList'
export default {
  mixins: [listMixin],
  data: () => ({
    listKey: 'cooperation-store-list',
    bindRoute: false,
    meta: {},
  }),
  methods: {
    async beforeIndex() {
      await Promise.all([])
    },
    async indexApi(params) {
      const member_id = this.$route.params.target
      return await this.$api.collection.memberApi.cooperation(params, member_id, 'store')
    },
    // 解綁
    async deleteApi(target, row) {
      const store_id = row.id
      const member_id = this.$route.params.target
      return await this.$api.collection.storeMemberApi.delete(store_id, member_id)
    },
    // 批次解綁
    async batchDeleteApi(targets, selectedData) {
      // const pivot_ids = selectedData
      //   .filter(item => item.id == targets)
      //   .map(item => item.provider_pivot.id)
      // return await this.$api.collection.storeMemberApi.batchDelete(pivot_ids)
    },
    getListConfig() {
      return listConfig
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
